import React from 'react';
import { useSelector } from 'react-redux';
import { capitalize } from 'lodash';
import useVouchers from 'products/nomad_insurance/hooks/useVouchers';
import { StyledFeedback } from './styled';

const VoucherFeedback = () => {
  const { hasEndDate } = useSelector(
    // @ts-ignore state is not typed
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );

  const isRecurring = !hasEndDate;
  const { availableVouchers } = useVouchers();

  if (!availableVouchers || availableVouchers.length === 0 || isRecurring) return null;

  return (
    <StyledFeedback variant="failure" topAlignIcon>
      {availableVouchers?.map((voucher) => (
        <span>
          You can only receive your ${voucher.amount} {capitalize(voucher.provider)}{' '}
          credit by choosing our pay-as-you-go option with no predefined end date. You can
          still cancel anytime.
        </span>
      ))}
    </StyledFeedback>
  );
};

export default VoucherFeedback;
